import React, { lazy, Suspense } from 'react';
import { ResponsiveGrid } from '@adobe/aem-react-editable-components';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { AEMReactCompMap } from '@marriott/mi-ui-library';
import clsx from 'clsx';
import { MSlotProps } from './MSlot.types';

export const MSlot: React.FC<MSlotProps> = props => {
  const {
    pagePath,
    itemPath,
    isAuthorMode = false,
    cqItems = {},
    allowedComponents = [],
    className = '',
    containerClassName = '',
    model,
  } = props;

  if (isAuthorMode) {
    return (
      <div className={clsx('m-slot', containerClassName)} data-test={JSON.stringify({ pagePath, itemPath })}>
        <div className={className}>
          <ResponsiveGrid
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            pagePath={pagePath}
            itemPath={itemPath}
            columnCount="12"
            gridClassNames={''}
            config={{
              isEmpty: () => true,
              resourceType: 'mi-aem-common-spa/components/container',
            }}
          />
        </div>
      </div>
    );
  }

  const mapper = AEMReactCompMap(allowedComponents);

  const renderComponents = () => {
    const components: React.ReactNode[] = [];

    const itemOrder = model?.[':order'] || Object.keys(cqItems);

    itemOrder.forEach((itemKey: string) => {
      if (!cqItems[itemKey]) return;

      const item = cqItems[itemKey];
      const itemType = item[':type']?.split('/').pop();

      if (!itemType || !mapper[itemType]) return;

      const componentName = mapper[itemType];
      const Component = lazy(() =>
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        import(`../../index`).then((module: any) => ({
          default: module[componentName],
        }))
      );

      components.push(
        <Suspense key={itemKey} fallback={<div className="m-slot__loading">Loading...</div>}>
          <Component {...item} />
        </Suspense>
      );
    });

    return components;
  };

  return (
    <div className={clsx('m-slot', containerClassName)} data-test={JSON.stringify({ pagePath, itemPath })}>
      <div className={className}>{renderComponents()}</div>
    </div>
  );
};

export default MSlot;
